import { useGateValue } from '@statsig/react-bindings';

export const MULTI_PACKAGE_GATE = 'multi_package_booking';

export function useMultiPackageGate(): boolean {
  return useGateValue(MULTI_PACKAGE_GATE);
}
